import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import {
  animate, AnimationBuilder, AnimationFactory, AnimationMetadata, AnimationPlayer,
  style
} from '@angular/animations';
import { ObserverService } from './observer.service';
export class AnimateInDirective implements OnInit{
   animateInAnimation;
  player: AnimationPlayer;
/**
 * @param {?} _observer
 * @param {?} el
 * @param {?} animationBuilder
 */
constructor(private _observer: ObserverService,
private el: ElementRef,
private animationBuilder: AnimationBuilder
  ) {}
/**
 * @return {?}
 */
ngOnInit() {
    let /** @type {?} */ animation: AnimationFactory;

    if ( this.animateInAnimation !== null && this.animateInAnimation !== undefined) {
      animation = this.animationBuilder.build(this.animateInAnimation);
    } else {
      animation = this.animationBuilder.build([
        style({opacity: 0, transform: 'translateX(-100px)'}),
        animate('1200ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 1, transform: 'translateX(0)'})),
      ]);
    }

    if (this._observer.isSupported()) {
      this.player = animation.create(this.el.nativeElement);
      this.player.init();
      this._observer.addTarget(this.el.nativeElement, this.startAnimating.bind(this));
    }
  }
/**
 * Builds and triggers the animation
 * when it enters the viewport
 * @param {?} inViewport
 * @return {?}
 */
startAnimating(inViewport: boolean) {
    if (inViewport) {
      this.player.play();
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[animateIn]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ObserverService, },
{type: ElementRef, },
{type: AnimationBuilder, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animateInAnimation': [{ type: Input },],
};
}

function AnimateInDirective_tsickle_Closure_declarations() {
/** @type {?} */
AnimateInDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AnimateInDirective.ctorParameters;
/** @type {?} */
AnimateInDirective.propDecorators;
/** @type {?} */
AnimateInDirective.prototype.animateInAnimation;
/** @type {?} */
AnimateInDirective.prototype.player;
/** @type {?} */
AnimateInDirective.prototype._observer;
/** @type {?} */
AnimateInDirective.prototype.el;
/** @type {?} */
AnimateInDirective.prototype.animationBuilder;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
